import AdsCarousel, {Ad} from './AdsCarouselView';

export {Ad};
export default AdsCarousel;
